import { ChangeDetectorRef, Component } from '@angular/core';
import { LoadingService } from './services/loading.service';
import { TokenService } from './services/token.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'tt-fe';

  constructor(
    public loadingService: LoadingService,
    public tokenService: TokenService,
  ) {}
}
